<template>
    <el-tabs value="latestCourses">
        <!-- Latest Releases -->
        <el-tab-pane label="Latest Releases" name="latestCourses">
            <div class="programs-listing">
                <div v-for="(courses, index) in getChunkedProgram(latestCourses)" :key="index" class="row">
                    <ghProgramCard
                            v-for="program in courses"
                            :key="program.id"
                            :program="program"
                            :new-window="true"
                            :is-credential="program && program.isCredential"
                            gridClass="col-xs-6 col-md-3">
                    </ghProgramCard>
                </div>
            </div>
        </el-tab-pane>

        <!-- Most Popular -->
        <el-tab-pane label="Most Popular" name="popularCourses">
            <div class="programs-listing">
                <div v-for="(courses, index) in getChunkedProgram(popularCourses)" :key="index" class="row">
                    <ghProgramCard
                            v-for="program in courses"
                            :key="program.id"
                            :program="program"
                            :new-window="true"
                            :is-credential="program && program.isCredential"
                            gridClass="col-xs-6 col-md-3">
                    </ghProgramCard>
                </div>
            </div>
        </el-tab-pane>

         <!--Collections-->
        <el-tab-pane v-if="courseType === 'membership-courses'" label="Collections" name="popularCollections">
            <div class="programs-listing">
                <div v-for="(collections, index) in getChunkedProgram(popularCollections)" :key="index" class="row">
                    <ghProgramCard
                            v-for="collection in collections"
                            :key="collection.id"
                            :program="collection"
                            :new-window="true"
                            gridClass="col-xs-6 col-md-3">
                    </ghProgramCard>
                </div>
            </div>
        </el-tab-pane>
        <div class="more">
            <a :href="isCredential ? '/credentials' : '/catalogue'" class="gh-button-redesign gh-button-redesign--primary gh-button-home-redesign" target="_blank">View More</a>
        </div>
    </el-tabs>
</template>

<script>
    import ghProgramCard from '../../../../components/course/programCard.vue';

    export default {
        components: {ghProgramCard},

        props: {
            courseType: {
                type: String,
                required: true
            }
        },

        created() {
            if(this.courseType === 'membership-courses') {
                if (! this.latestCourses.length) {
                    this.$store.dispatch('course/getLatestCourses');
                }

                if (! this.popularCourses.length) {
                    this.$store.dispatch('course/getPopularCourses');
                }

                if (! this.popularCollections.length) {
                    this.$store.dispatch('course/getPopularCollections');
                }
            } else {
                if (! this.latestCourses.length) {
                    this.$store.dispatch('credential/getLatestCourses');
                }
                if (! this.popularCourses.length) {
                    this.$store.dispatch('credential/getPopularCourses');
                }
            }
        },

        computed: {
            latestCourses() {
                if (this.courseType === 'membership-courses') {
                    return this.$store.state.course.latestCourses;
                } 
                return this.$store.state.credential.latestCourses;
            },

            popularCourses() {
                if (this.courseType === 'membership-courses') {
                    return this.$store.state.course.popularCourses;
                }
                return this.$store.state.credential.popularCourses;
            },

            popularCollections() {
                if (this.courseType !== 'membership-courses') {
                    return [];
                } 
                return this.$store.state.course.popularCollections;
            },

            isCredential() {
                return this.latestCourses.length > 0 && this.latestCourses[0].isCredential
            }
        },

        methods: {
            getChunkedProgram(programs, size = 4) {
                return _.chunk(programs, size);
            }
        }
    }
</script>